module.exports = __webpack_public_path__ + "img/habitation_mobile.be1fb9cc.jpg";